<template>
  <div class="d-flex flex-column align-stretch mb-8 avatar-wrapper">
    <v-alert v-model="showError" color="red lighten-2" dismissible dark>
      {{ errorMessage }}
    </v-alert>
    <div class="mb-4 avatar-container">
      <v-skeleton-loader
        v-if="mediaLoading"
        width="160"
        height="160"
        type="card-avatar"
        tile
      ></v-skeleton-loader>
      <div v-else class="d-flex flex-row flex-wrap">
        <media-avatar
          v-for="(image, index) in tripMedia"
          :key="index"
          :media="image"
          tile
          size="160"
          class="mr-4 mb-4"
          :deleteMedia="showDelete"
          @delete="removeMedia"
        />
      </div>
    </div>
    <div>
      <input
        type="file"
        ref="filePicker"
        style="display:none"
        accept="image/*"
        multiple
        @change="mediaChange"
      />
      <v-btn
        outlined
        class="text-capitalize font-weight-bold text-primary"
        :loading="mediaLoading"
        @click="$refs.filePicker.click()"
      >
        <img src="@/assets/icons/icon-image.svg" class="mr-1" alt />Upload Image
      </v-btn>
    </div>
  </div>
</template>

<script>
import MediaAvatar from '@/components/MediaAvatar'

export default {
  props: {
    tripMedia: {
      type: Array
    },

    mediaLoading: {
      type: Boolean,
      default: false
    },

    updateImage: {
      type: Boolean,
      default: false
    },

    error: {
      type: Array
    }
  },

  components: {
    MediaAvatar
  },

  data() {
    return {
      showError: false,
      errorMessage: ''
    }
  },

  computed: {
    showDelete() {
      if (this.updateImage) {
        return this.tripMedia.length > 1
      }

      return true
    }
  },

  watch: {
    error() {
      this.showError = this.error != null
      this.errorMessage = this.error != null ? this.error[0] : ''
    }
  },

  methods: {
    mediaChange(image) {
      this.$emit('change', image.target.files)
      this.$refs.filePicker.value = null
    },

    removeMedia(mediaId) {
      this.$emit('delete', mediaId)
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-container {
  overflow-y: auto;
  max-height: 350px;
}
</style>
